import { WarningEventType } from 'redux-state/weather-warnings/types-events.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { WarningSeverity } from 'utilities/weather-warnings/warning-severity.js';

export type R = (typeof WarningSeverity)[keyof typeof WarningSeverity];
type WarningSeverityObject = Record<R, IWarning[]>;
type WarningSeverityByWeatherType = {
  [K in WarningEventType]: WarningSeverityObject;
};

const createObjectByEventType = (warnings: ReadonlyArray<IWarning>) => {
  // Sort warnings by event type, sort mutates array so we need to copy it first
  const sortedWarnings = [...warnings].sort((a, b) => {
    const result = a.eventType.localeCompare(b.eventType);
    return result;
  });
  // Create array based on unique eventTypes
  const warn = sortedWarnings.reduce<WarningSeverityByWeatherType>((acc, warning) => {
    if (!acc[warning.eventType]) {
      acc[warning.eventType] = {} as WarningSeverityObject;
    }
    const eventObj = acc[warning.eventType];
    if (!eventObj[warning.warnLevel]) {
      eventObj[warning.warnLevel] = [];
    }
    acc[warning.eventType][warning.warnLevel] = acc[warning.eventType][warning.warnLevel]
      .concat(warning)
      .sort((a, b) => (a.subType ?? 'z').localeCompare(b.subType ?? 'z'));

    return acc;
  }, {} as WarningSeverityByWeatherType);

  return warn;
};

export const getPanelBodyList = ({ warnings }: { warnings: ReadonlyArray<IWarning> }) => {
  const sortedWarn = createObjectByEventType(warnings);
  const sortedWarn1 = Object.values(sortedWarn);
  const sortedWarn2 = sortedWarn1.map((v) => {
    return Object.values(v).map((warnArr) => {
      const { type, eventType, subType } = warnArr[0];
      const key = `${eventType}${type}${subType}`;
      return {
        key,
        warnArr,
      };
    });
  });
  return sortedWarn2.flat();
};
